export default __webpack_public_path__ + "static/startButton-30015264a7e26ea882fa628908d59aab.svg";